export const ATTENTION_DWELL_MS = 1500;
export const ATTENTION_REARM_MS = 3000;
export function attentionEpisode(state: { since: number | null; counted: boolean; leftAt: number | null }, focused: boolean, now: number): boolean {
  if (!focused) {
    state.since = null;
    state.leftAt ??= now;
    if (now - state.leftAt >= ATTENTION_REARM_MS) state.counted = false;
    return false;
  }
  if (state.leftAt !== null && now - state.leftAt >= ATTENTION_REARM_MS) state.counted = false;
  state.leftAt = null;
  state.since ??= now;
  if (state.counted || now - state.since < ATTENTION_DWELL_MS) return false;
  state.counted = true;
  return true;
}
